module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAaklEQVQoU23NwQ3CMBBE0T8S3aQhLpQCSaAULjREN0iDJrKtxcIn7/rpWwC2F0nv3OfT32T7BlyBi6RXhbbPwBN4dLgDn4oLOgGb2tepDtyqKQWtku4H/IOzGijDgBPOeJR66AcWTEXZfwGlRTH/Qjyl0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/selected.png
// module id = PMry
// module chunks = 3